import React from 'react';
import styled from 'styled-components';

import { grey50 } from 'variables/colors';
import { fontWeightSemiBold } from 'variables/font';

export const Detail = styled.div`
  &:not(:last-of-type) {
    margin-right: 2em;
  }
`;

export const DetailLabel = styled.label`
  color: ${grey50};
  font-weight: ${fontWeightSemiBold};
  font-size: 0.625em;
`;

export const DetailValue = styled.h5`
  margin-top: 0.5em;
`;

const ModalDetailStat = ({ label, value }) => (
  <Detail>
    <DetailLabel>{label}</DetailLabel>
    <DetailValue>{value}</DetailValue>
  </Detail>
);

export default ModalDetailStat;
